/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "./Base";

@Component
export default class AlertMixin extends Base {
  getAlert(id: string, tag: string) {
    const url = API_ENDPOINT + `/me/alerts/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getAlerts(tag: string) {
    const url = API_ENDPOINT + `/me/alerts.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  createAlert(data: any, tag: string) {
    const url = API_ENDPOINT + `/me/alerts.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data: data,
    });
  }

  updateAlert(id: number, data: any, tag: string) {
    const url = API_ENDPOINT + `/me/alerts/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PUT",
      data: data,
    });
  }

  deleteAlert(id: number, tag: string) {
    const url = API_ENDPOINT + `/me/alerts/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "DELETE",
    });
  }
}
